module.exports = __webpack_public_path__ + "img/Zpt.08b125fd.svg";